export interface BonusType {
  amountType: { id: number; name: 'Amount' }
  baseType: { id: number; name: 'Restricted' }
  bonusAmount: number
  id: string
  name: string
  absoluteExpiryDate: null | string
  relativeExpiryInDays: number
  lotsRequired: number
  lotsRequiredType: { id: 10; name: 'Amount' } | { id: 20; name: 'Percent' }
}

export enum TransactionBonusKey {
  reference = 'referenceId',
  client = 'client.name',
  wallet = 'wallet.name',
  tradingAccount = 'tradingAccount.login',
  bonusType = 'bonusType.name',
  baseType = 'bonusType.baseType.name',
  bonusTransactionStatus = 'bonusTransactionStatus.name',
  bonusAmount = 'amount',
  currency = 'wallet.currency.id',
  reservedAmount = 'bonusReserved',
  lotsRequired = 'lotsRequired',
  lotsTraded = 'lotsTraded',
  expiryDate = 'expiryDate',
  linkedDeposits = 'linkedDeposits',
  tickmillCompany = 'client.tickmillCompany.name',
  createdDate = 'createdDate',
  updatedDate = 'updatedDate',
  comment = 'comment',
}

export enum TransactionBonusFilterKey {
  reference = 'Reference',
  client = 'Client',
  wallet = 'WalletId',
  campaign = 'Campaign',
  transactionState = 'TransactionState',
  bonusType = 'BonusTypeId',
  bonusTransactionStatus = 'BonusTransactionStatusId',
  bonusAmount = 'Amount',
  reservedAmount = 'BonusReserved',
  expiryDate = 'ExpiryDate',
  bonusLabel = 'BonusLabel',
}
